import { useEffect, useState, useCallback } from "react";
import { Trash2, Star, Loader2 } from "lucide-react";

import { AdminHeader } from "@/components/admin/AdminHeader";
import { adminApi } from "@/lib/adminApi";

const FILTERS = [
  { v: "", label: "Toutes" },
  { v: "permanent", label: "⭐ Permanents" },
  { v: "validated", label: "✓ Validées" },
];

export default function AdminHistoryPage() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const { items } = await adminApi.history(filter);
      setItems(items || []);
    } finally {
      setLoading(false);
    }
  }, [filter]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const onDelete = async (it) => {
    if (!window.confirm(`Supprimer la validation pour "${it.artist} — ${it.title}" ?`)) return;
    await adminApi.deleteArtwork(it.artist, it.title);
    refresh();
  };

  return (
    <div className="mw-app">
      <AdminHeader />
      <main className="admin-main">
        <div className="admin-pagehead">
          <div>
            <span className="mw-section-eyebrow">Mémoire validée</span>
            <h1 className="admin-h1">Historique</h1>
            <p className="admin-lead">
              Toutes les pochettes que vous avez validées. Les permanents sont protégés
              de l'écrasement automatique.
            </p>
          </div>
          <div className="admin-filters">
            {FILTERS.map((f) => (
              <button
                key={f.v}
                type="button"
                className={
                  filter === f.v
                    ? "mw-btn mw-btn-primary admin-filter-btn"
                    : "mw-btn mw-btn-ghost admin-filter-btn"
                }
                onClick={() => setFilter(f.v)}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        {loading ? (
          <div className="admin-loading"><Loader2 size={18} className="mw-spin" /> Chargement…</div>
        ) : items.length === 0 ? (
          <div className="admin-empty">Aucune validation pour ce filtre.</div>
        ) : (
          <div className="admin-history-list">
            {items.map((it) => (
              <article key={`${it.artist}-${it.title}`} className="admin-history-row">
                <img src={it.artwork_url} alt="" className="admin-history-thumb" loading="lazy" />
                <div className="admin-history-info">
                  <div className="admin-history-title">
                    {it.title}
                    {it.status === "permanent" && (
                      <Star size={13} className="admin-history-star" />
                    )}
                  </div>
                  <div className="admin-history-artist">{it.artist}</div>
                  <div className="admin-history-meta">
                    {it.source} · {it.updated_at?.slice(0, 16).replace("T", " ")}
                  </div>
                </div>
                <button
                  type="button"
                  className="admin-history-del"
                  onClick={() => onDelete(it)}
                  title="Supprimer cette validation"
                >
                  <Trash2 size={14} />
                </button>
              </article>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
